import { PaginationParams } from "../type";

export const LOCATION_KEYS = {
  LOCATIONS: "locations",
  SETTINGS: "storage_settings",
  GET_LOCATIONS: (params?: PaginationParams) => [
    LOCATION_KEYS.LOCATIONS,
    params,
  ],
  GET_STORAGE_SETTINGS: () => [LOCATION_KEYS.SETTINGS],
};

